import { FC, useContext } from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import {
  Box,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "../Styles/PopOverStyles";
import logoutProfile from "../../assets/images/logoutProject.svg";
import { NavLink } from "react-router-dom";
import { PopoverProps } from "../../interfaces";
import AuthContext from "../../store/Auth/AuthContext";
import SettingsIcon from "../../assets/images/profileListIcons/settings.svg";
import StakingIcon from "../../assets/images/profileListIcons/staking.svg";
import MyPortfolioIcon from "../../assets/images/profileListIcons/my-portfolio.svg";
import WalletIcon from "../../assets/images/profileListIcons/wallet-icon.svg";
import NoTierLogo from "../../assets/images/noTierLogo.svg";
import FishLogo from '../../assets/images/fishes.png';
import PlanktonLogo from '../../assets/images/planktons.png';
import SharksLogo from '../../assets/images/sharks.png';
import DolphinLogo from '../../assets/images/dolphins.png';
import WhaleLogo from '../../assets/images/whales.png';
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import { tierLevel, nextTierRequirement } from "../../utils/constants/helpers";
import TierLevel from "../Profile/TierLevel";

const ProfilePopover: FC<PopoverProps> = ({
  id,
  open,
  anchorEl,
  handleClose,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { getProfileData, Logout } = useContext<any>(AuthContext);
  const { lockedGains } = useContext<any>(SubscriptionContext);
  function logoutUser() {
    Logout();
  }


  const tierLogo = (tier: number) => {
    switch (tier) {
      case 1:
        return WhaleLogo;
      case 2:
        return SharksLogo;
      case 3:
        return DolphinLogo;
      case 4:
        return FishLogo;
      case 5:
        return PlanktonLogo;
      default:
        return NoTierLogo;
    }
  }


  return (
    <>
      <Popover
        className={classes.popoverpages}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock={false}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      
      >
        <Box m={"1.25rem 0.75rem"}   style={{width: "216px"}}>
          <Box 
            display={"flex"} 
            justifyContent="center"
            flexDirection={"column"}
            alignItems={"center"}
            mb={"0.875rem"}
            padding={"0 0.5rem"}
          >
            <img src={tierLogo(getProfileData?.learnpad_tier)} style={{width:"5.6rem"}}  alt="tier-level" />
            <Typography
            color="secondary"
            className={classes.profileUsername}
            >{getProfileData?.username}</Typography>
            <Typography 
            className={classes.tierLevel}
            >
              {tierLevel(getProfileData?.learnpad_tier)}
            </Typography>
          </Box>
          <TierLevel />
          <div className={classes.profileDivider} />
          <Box mt={"0.75rem"}>
            <Box className={classes.listRowHover}>
              <NavLink
                className={classes.listRow}
                to="/portfolio"
                color="secondary"
              >
                <Typography variant="body1" color="secondary" className={classes.listTitle}>
                  My Portfolio
                </Typography>
                <img src={MyPortfolioIcon} alt="My Portfolio"  />
              </NavLink>
            </Box>
            <Box className={classes.listRowHover}>
              <NavLink
                className={classes.listRow}
                to="/wallets"
                color="secondary"
              >
                <Typography variant="body1" color="secondary" className={classes.listTitle}>
                  My Wallets
                </Typography>
                <img src={WalletIcon} alt="My Portfolio"  />
             </NavLink>
            </Box>
            <Box className={classes.listRowHover}>
             <NavLink
                className={classes.listRow}
                to="/gains"
                color="secondary"
              >
                <Typography variant="body1" color="secondary" className={classes.listTitle}>
                  Staking
                </Typography>
                <img src={StakingIcon} alt="GAINS Staking"  />
              </NavLink>
            </Box>
            <Box className={classes.listRowHover}>
              <NavLink
                to="/profile-settings/0"
                color="secondary"
                className={classes.listRow}
              >
                <Typography variant="body1" color="secondary" className={classes.listTitle}>
                  Settings
                </Typography>
                <img src={SettingsIcon} alt="Settings"  />
              </NavLink>
            </Box>
            {/* <Box className={classes.listRowHover}>
              <Link
                className={classes.listRow}
                target="_blank"
                href="https://forms.gle/zqsmPubnaHejvt9QA"
                color="secondary"
              >
                <Typography variant="body1" color="secondary" className={classes.listTitle}>
                  Suggest Project
                </Typography>
                <img src={SuggestIcon} alt="Suggest Project"  />
              </Link>
            </Box> */}
            {/* <Box mb={"0.5rem"} className={classes.listRowHover}>
              <Link
                className={classes.listRow}
                target="_blank"
                href="https://t.me/+tIwaCtq58KthMDQ8"
                color="secondary"        
              >
                <Typography variant="body1" color="secondary" className={classes.listTitle}>
                Support
                </Typography>
                <img src={SupportIcon} alt="Support"  />
              </Link>
            </Box> */}
          </Box>
          <div className={classes.profileDivider}/>
          <Box 
            className={`${classes.listRow} ${classes.listRowHover}`} 
            marginTop=".5rem" 
            style={{marginBottom:"-.75rem", width:"calc(100% - 1rem)"}}
            onClick={logoutUser}
          >
            <Typography variant="body1" color="secondary" className={classes.listTitle}>
              Log out
            </Typography>
            <img
              src={logoutProfile}
              alt="Profile"
            />
          </Box>   
        </Box>
      </Popover>
    </>
  );
};
export default ProfilePopover;
